import Marquee from "react-fast-marquee";

const words = ["Resorts", "Plages", "Couchers de soleil", "Piscines à débordement", "Souvenirs", "Vacances", "Voyages", "Émotions"];

export default function EditorialMarquee() {
  return (
    <div className="py-8 md:py-12 border-y border-[#E4E4E7] bg-[#F9FAFB] overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={38} gradient={false}>
        {words.map((w, i) => (
          <span key={i} className="mx-8 text-5xl md:text-7xl font-black tracking-tighter text-stroke uppercase select-none">
            {w} <span className="text-[#F97316] not-italic">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
